@import 'apps/webcomponents/src/assets/common.scss';
:host {
  --grid-max-height: 50vh;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;

  .grid {
    height: 100%;
    padding: 0 20px;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

::part(gridToolbar) {
  display: none;
}
